import { render, staticRenderFns } from "./ShopBrandXY.vue?vue&type=template&id=4667ec50&scoped=true"
import script from "./ShopBrandXY.vue?vue&type=script&lang=js"
export * from "./ShopBrandXY.vue?vue&type=script&lang=js"
import style0 from "./ShopBrandXY.vue?vue&type=style&index=0&id=4667ec50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4667ec50",
  null
  
)

export default component.exports